import { render, staticRenderFns } from "./MenuDetailPage.vue?vue&type=template&id=1cf00b54"
import script from "./MenuDetailPage.vue?vue&type=script&lang=js"
export * from "./MenuDetailPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports